// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uy6C","type":"styles_type__3htCA","choices":"styles_choices__LjIY7"};